import { render, staticRenderFns } from "./OngoingItems.vue?vue&type=template&id=7d345e24&"
import script from "./OngoingItems.vue?vue&type=script&lang=js&"
export * from "./OngoingItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports